import React from 'react'
import Navbar from './components/navbar/Navbar'
import Main from './pages/main/Main'
import Footer from './components/footer/Footer'

const App = () => {
     return (
          <>
               <Navbar />
               <Main />
               <Footer />
          </>
     )
}

export default App
